import './bootstrap';
import 'admin-lte';

import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createHead } from '@vueuse/head'
import axios from 'axios';

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
    components,
    directives,
})

import Form from 'vform';
window.Form = Form;

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

import Editor from '@tinymce/tinymce-vue';

// Widgets
import RightModalWidget from './components/widgets/RightModalWidget.vue'
import InfoWidget from './components/widgets/InfoWidget.vue'
import SearchWidget from './components/widgets/SearchWidget.vue'
import EditListWidget from './components/widgets/EditListWidget.vue'
import DropInput from './components/widgets/DropInput.vue'
import DropInputMulti from './components/widgets/DropInputMulti.vue'
import ScreenshotManager from './components/widgets/ScreenshotManager.vue';
import DocumentationList from './components/widgets/DocumentationList.vue';
import DocumentationAdd from './components/widgets/DocumentationAdd.vue';
import ContactForm from './components/widgets/ContactForm.vue';
import StarWidget from "./components/widgets/StarWidget.vue";

// Components
import Footer from './components/footer.vue'
import {Bootstrap4Pagination} from 'laravel-vue-pagination'

// Plugins
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import Swal from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

import Gate from "./Gate";
import routes from './routes';

// Инициализация router и head
const router = createRouter({
    routes,
    history: createWebHistory(),
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

const head = createHead()

const app = createApp({
    data() {
        return {
            menu_right: '1',
            app_count: ''
        }
    }
});

// Глобальные свойства
app.config.globalProperties.$gate = new Gate(window.user);
app.config.globalProperties.$axios = axios;

// Глобальные компоненты
app.component("v-select", vSelect);
app.component("Editor", Editor);
app.component('pagination', Bootstrap4Pagination)
//app.component('site-component', require('./components/page/site/AppListPage.vue').default);
app.component('site-component', require('./components/page/site/index.vue').default);
app.component('footers-page', Footer)
app.component('info-widget', InfoWidget)
app.component('stars-widget', StarWidget)
app.component('drop-widget', DropInput)
app.component('drop-multi-widget', DropInputMulti)
app.component('right-modal-widget', RightModalWidget)
app.component('search-widget', SearchWidget)
app.component('editlist-widget', EditListWidget)
app.component('screenshot-manager-widget', ScreenshotManager)
app.component('documentation-add-widget', DocumentationAdd)
app.component('documentation-list-widget', DocumentationList)
app.component('contact-form-widget', ContactForm)
app.component('app-page', require('./components/page/site/AppListPage.vue').default)

// Плагины
app.use(ToastPlugin, {
    position: 'top-right'
})
app.use(vuetify)
app.use(router);
app.use(Swal);
app.use(VueViewer)
app.use(head) // Подключаем @vueuse/head

window.Swal = app.config.globalProperties.$swal;

const vm = app.mount('#app')
